import React from 'react';
import { Audio } from '../../../../contexts';
import { Box } from '../../../Box';
import { Flex } from '../../../Flex';
import { AudioBar } from '../AudioBar';
import { PlayButton } from '../PlayButton';
export var QuickAudioPlayer = function QuickAudioPlayer(_ref) {
  var src = _ref.src,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'green' : _ref$color;
  return /*#__PURE__*/React.createElement(Audio, {
    src: src
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 1
  }, /*#__PURE__*/React.createElement(Box, {
    mr: "24px"
  }, /*#__PURE__*/React.createElement(PlayButton, {
    color: color
  })), /*#__PURE__*/React.createElement(AudioBar, {
    color: color
  })));
};